

































































import BaseInput from '../models/base.input';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
@Component({
  props: {
    options: Array,
    disabled: [Boolean, Number],
    tabindex: Number,
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
  },
})
export default class Select extends BaseInput {

  @Prop()
  allowEmpty!: Boolean;

  @Prop()
  tabindex!: Number;

   @Prop()
  multiple!: Boolean;

   @Prop()
  taggable!: Boolean;
  
  @Prop()
  options!: Array<any>;

  @Prop({ default: 0 })
  offset!: Number;

  @Prop()
  autoLabelCols: any;

  optionsWithEmpty: any = this.allowEmpty ? [{ key: -1, value: '...' }] : [];

  lab(opt: any) {
    const option = this.optionsWithEmpty.find((x: any) => x.key == opt);
    return option ? option.value : '';
  }
  
  selectAll() {
    this.$emit('input', this.options.map(m => m.key));
  }

  unSelectAll() {
    this.$emit('input', []);
  }

  inputHandler(e: any) {
    if (e == -1) {
      e = null;
    }
    this.$emit('input', this.multiple ? e : e + '');
  }

  addTag(val) {
    const tag = {
      key: val,
      value: val,
    };
    this.options.push(tag);
    //@ts-ignore
    let data = this.value;
    data.push(val);
    this.$emit('input', data);
  }

  created() {
    if (this.options) {
      this.optionsWithEmpty = this.optionsWithEmpty.concat(this.options);
    }
  }

  @Watch('optionsWithEmpty')
  onIsOptionsChanged(val: Array<any>, oldVal: Array<any>) {
    if (
      val &&
      val.length > 0 &&
      !val.find((x: any) => x.key == -1) &&
      this.allowEmpty
    ) {
      this.optionsWithEmpty.unshift({ key: -1, value: '...' });
    } else if (val && val.length == 0 && this.allowEmpty) {
      this.optionsWithEmpty = [{ key: -1, value: '...' }];
    }
  }
  @Watch('options')
  onOptionsChanged(val: Array<any>, oldVal: Array<any>) {
    this.optionsWithEmpty = val.slice();
  }
}
